import { ListBoxItem, type ListBoxItemProps } from "react-aria-components";

import { cn } from "#utils";

interface CustomListItemProps extends ListBoxItemProps {
  children: React.ReactNode;
  className?: string;
  /** If true, allows content to wrap instead of truncating with ellipsis */
  allowWrap?: boolean;
}

/**
 * A styled ListBoxItem component for use in dropdown menus.
 * Provides consistent styling for hover, focus, and selected states.
 */
export function CustomListItem({
  children,
  className,
  allowWrap = false,
  ...props
}: CustomListItemProps) {
  return (
    <ListBoxItem
      className={({ isHovered, isFocusVisible, isSelected }) =>
        cn(
          "cursor-pointer border-r px-4 py-2 text-body-small",
          isHovered || isFocusVisible || isSelected
            ? "border-outline-brand bg-overlay-brand"
            : "border-overlay-medium",
          className,
        )
      }
      {...props}
    >
      <div
        className={
          allowWrap ? "overflow-hidden" : "overflow-hidden text-ellipsis whitespace-nowrap"
        }
      >
        {children}
      </div>
    </ListBoxItem>
  );
}
